import { useState } from 'react'

import { GeoDbCity, GeoDbCountry, GeoDbProvince } from '@/_gql/graphql'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

import { dateFormat } from '@/lib/formatter'

interface FamilyProps {
  family:
    | {
        name: string | undefined
        relation: string | undefined
        birthdate: string | undefined
        city: GeoDbCity | undefined
        province: GeoDbProvince | undefined
        religion: string | undefined
        country: GeoDbCountry | undefined
        nationality: GeoDbCountry | undefined
        phone_number: string | undefined
      }[]
    | undefined
}
export function Family(props: FamilyProps) {
  const { family } = props
  const [show, setShow] = useState<boolean>(true)
  const idAccordion = 'family'
  return (
    <>
      <Accordion
        defaultValue={idAccordion}
        type="single"
        collapsible
        className="w-full rounded-md border-t-4 border-t-[#D91F2E] bg-white"
        onValueChange={(value) => setShow(value === idAccordion)}
      >
        <AccordionItem value={idAccordion} className="border-none p-0">
          <AccordionTrigger className="border-b border-b-[#EAECF0] p-6">
            <div className="flex w-full items-center justify-between">
              <div>Keluarga</div>
              <div className="text-xs">{show ? 'Sembunyikan' : ''}</div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="w-full">
            {family?.length == 0 ? (
              <div className="flex justify-center p-4">Tidak ada data</div>
            ) : (
              <></>
            )}
            <div className="flex w-full flex-col gap-4 divide-y">
              {family?.map((t, key) => (
                <div className="grid w-full grid-cols-4 gap-4 p-6">
                  <div className="flex flex-col">
                    <div className="font-semibold">Nama anggota keluarga</div>
                    <div>{t.name}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Hubungan dengan user</div>
                    <div>{t.relation}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Nomor HP</div>
                    <div>{t.phone_number}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Tanggal lahir</div>
                    <div>
                      {t.birthdate
                        ? dateFormat(t.birthdate, 'MM/dd/yyyy') || '-'
                        : '-'}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Tempat Lahir</div>
                    <div>{`${t.city?.name}, ${t.province?.name}, ${t.country?.name}`}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Agama</div>
                    <div>{t.religion}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Kewarganegaraan</div>
                    <div>{t.nationality?.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  )
}
